import React from "react";

const JobByTitle = () => {
  return (
    <>
      <div className="widget">
        <h4 className="widget-title">Jobs By Title</h4>
        <ul className="optionList view_more_ul hide_vm_ul">
          <li>
            <input type="checkbox" className="form-check-input" />
            <label htmlFor="job_title_0" />
            IOS Developer <span>1</span>
          </li>
          <li>
            <input type="checkbox" className="form-check-input" />
            <label htmlFor="job_title_1" />
            Electrical Engineer <span>1</span>{" "}
          </li>
          <li>
            <input type="checkbox" className="form-check-input" />
            <label htmlFor="job_title_2" />
            Laravel Developer <span>1</span>{" "}
          </li>
          <li>
            <input type="checkbox" className="form-check-input" />
            <label htmlFor="job_title_3" />
            PHP Developer Required <span>2</span>{" "}
          </li>
          <li>
            <input type="checkbox" className="form-check-input" />
            <label htmlFor="job_title_4" />
            Php Developer Required <span>2</span>{" "}
          </li>
        </ul>
        {/* title end */}
        <button type="button" className="btn view_more">View More</button>{" "}
      </div>
    </>
  );
};

export default JobByTitle;
